'use client'

import { useStoreI18n } from '@/store'
import { Typo3Page } from '@/types'
import { Locale } from '@spot'
import { memo, useLayoutEffect } from 'react'

interface LangRoutesProps {
  data: Typo3Page['i18n']
  locale: Locale
}

const LangRoutes = ({ ...props }: LangRoutesProps) => {
  const setCurrentRoutes = useStoreI18n.use.setCurrentRoutes()

  useLayoutEffect(() => {
    setCurrentRoutes(props.data?.filter((item) => item.available === 1))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

export default memo(LangRoutes)
